import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import Notification from "../components/Notification";
import Loading from "../components/Loading";
import { CiCirclePlus } from "react-icons/ci";
import { GoFileZip } from "react-icons/go";
import { useAuth } from "../hooks/AuthProvider";
import InvoicesTable from "../components/InvoicesTable";
import InvoiceModal from "../components/InvoiceModal";
import { createInvoice as createInvoiceServer } from "../services/invoicesService";
import { getTags } from "../services/tagService";

const ShowPage = () => {
	const [tags, setTags] = useState(null);
	const [searchParams] = useSearchParams();
	const [invoices, setInvoices] = useState([]);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("Fatture");
	const [success, setSuccess] = useState(null);
	const [sumImport, setSumImport] = useState(0);
	const auth = useAuth();

	//Modale
	const [createInvoice, setCreateInvoice] = useState(null);

	const tagId = searchParams.get("tag");
	const sellerId = searchParams.get("seller");

	useEffect(() => {
		setLoading(true);
		getTags(auth, false)
			.then(setTags)
			.catch(setError)
			.finally(() => setLoading(false));
	}, [auth]);

	const handleDownloadZip = () => {
		const token = auth.token;

		let viewerUrl;
		if (sellerId)
			viewerUrl = `${
				process.env.REACT_APP_API_URL
			}invoices/seller/${sellerId}/zip?token=${encodeURIComponent(token)}`;
		else if (tagId)
			viewerUrl = `${
				process.env.REACT_APP_API_URL
			}invoices/tag/${tagId}/zip?token=${encodeURIComponent(token)}`;
		else {
			setError("Errore nel download del ZIP");
			return;
		}

		window.open(viewerUrl, "_blank");
	};

	const handleCreateInvoice = async (invoice) => {
		setSuccess(null);
		setError(null);
		if (await createInvoiceServer(auth, sellerId, invoice)) {
			let newInvoices = [{ ...invoice, justUploaded: true }, ...invoices];
			setInvoices(newInvoices);
			setSuccess("Fattura creata con successo.");
		} else setError("Errore nella creazione della fattura.");

		setCreateInvoice(null);
	};

	if (loading) return <Loading />;

	return (
		<AuthenticatedLayout title={title}>
			{error && <Notification notification={{ type: 0, message: error }} />}
			{success && <Notification notification={{ type: 3, message: success }} />}

			<div className="columns is-vcentered mb-4 is-size-5">
				<div
					className="column is-flex is-justify-content-start is-clickable"
					onClick={handleDownloadZip}
				>
					<GoFileZip />
					<span className="ml-2">Scarica ZIP</span>
				</div>

				{sellerId && (
					<div
						className="column is-flex is-justify-content-end is-clickable"
						onClick={() => setCreateInvoice(true)}
					>
						<CiCirclePlus />
						<span className="ml-2">Carica Nuova</span>
					</div>
				)}
				{tagId && (
					<div className="column is-flex is-justify-content-end">
						<span className="ml-2">
							Totale:{" "}
							{sumImport.toLocaleString("it-IT", {
								style: "currency",
								currency: "EUR",
							})}
						</span>
					</div>
				)}
			</div>

			<InvoicesTable
				mode={tagId ? "tag" : "seller"}
				invoices={invoices}
				setError={setError}
				tagId={tagId}
				sellerId={sellerId}
				setInvoices={setInvoices}
				auth={auth}
				setSumImport={setSumImport}
				setSuccess={setSuccess}
				setTitle={setTitle}
			/>

			{/* Modal per la creazione */}
			{createInvoice && (
				<InvoiceModal
					invoice={null}
					onClose={() => setCreateInvoice(null)}
					onSave={handleCreateInvoice}
					tags={tags}
				/>
			)}
		</AuthenticatedLayout>
	);
};

export default ShowPage;
